<main class="container notifications">
  <header fxLayout fxLayoutAlign="space-between center">
    <h1 i18n class="h5 gray-1" i18n>Notifications</h1>
    <button mat-flat-button color="primary" *ngIf="hasUnread" (click)="setAllUnread()" class="all-unread" i18n
      >Set all read</button
    >
  </header>
  <app-notifications-list></app-notifications-list>
</main>
